import React from "react";

const UserListTr = () => {
    return (
        <>
            <tr>
                <td>
                    <div className="d-flex px-2 py-1">
                        <div className="d-flex flex-column justify-content-center">
                            <p className="text-xs text-secondary mb-0">1</p>
                        </div>
                    </div>
                </td>
                <td>
                    <p className="text-xs font-weight-bold mb-0">Pranay Masulkar</p>
                </td>
                <td>
                    <p className="text-xs text-secondary mb-0">8624043380</p>
                </td>
                <td>
                    <p className="text-xs text-secondary mb-0"> pranay@gmail.com </p>
                </td>
                <td className="align-middle text-start text-sm">Buyer</td>
                <td className="align-middle text-center">
                    <span className="badge badge-sm bg-gradient-success">Active</span>
                </td>
                <td className="align-middle"></td>
            </tr>
        </>
    );
};

export default UserListTr;
